<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Library"
                   :links="[{title:'Home', url:'/'},{title:'Library',url:'/about'},{title:'Rules'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="5"></sidebar>
        </section>
        <section class="content">
          <div class="flex heading-black1 justify-center uppercase font-serif">library rules & regulation</div>
          <div class="space-y-8">
            <div>
              <div class="heading-black2 font-serif">General Rules:</div>
              <div>
                <UnorderedList :ItemList="Rules"/>
              </div>
            </div>
            <div>
              <div class="heading-black2 font-serif">Circulation Rules:</div>
              <div>
                <UnorderedList :ItemList="circulations"/>
              </div>
            </div>
            <div>
              <div class="heading-black2 font-serif">Rules for Issuing Books:</div>
              <blockquote class="text-gray-600 text-justify font-medium">
                <p>Any Library material is taken out of the library for photocopying will have to be returned within an
                  hour. Necessary action will be taken against the defaulters.</p>
              </blockquote>
              <div>
                <UnorderedList :ItemList="issueRules"/>
              </div>
            </div>
          </div>
        </section>
      </div>
      <programmes></programmes>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/library/Sidebar";
import Programmes from "@/views/about/Programmes";
import UnorderedList from "@/components/UnorderedList"

export default {
  name: "Rules",
  components: {
    Programmes,
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent, UnorderedList
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      Rules: [
        'Please maintain silence in the library.',
        'Use of mobile phones is strictly prohibited. If any user is found talking on the phone strict action will be taken against that person.',
        'Smoking, eating, chewing gum and tobacco are strictly prohibited.',
        'Students are supposed to keep their bags, personal reading material and other belongings outside the library. THE LIBRARY STAFF IS NOT RESPONSIBLE FOR THE LOSS OR DAMAGE OF THE STUDENTS BELONGINGS.',
        'Students will be allowed to use the library during Free Periods only and after 5 pm.',
        'Students are requested to keep the books/magazines or any other material used in their respective places after use.',
        'Books returned to the library will not be issued to anyone for a period of 3 hours.',
        'If a book is lost, the concerned person has to replace the lost book with a new book, as well as pay the fine.',
      ],
      Books: [
        {
          no: "01",
          category: "Faculty",
          books: "05",
          lPeriod: "One week"
        },
        {
          no: "02",
          category: "Visiting Faculty",
          books: "02",
          lPeriod: "Seven Days"
        },
        {
          no: "03",
          category: "FE Students",
          books: "02",
          lPeriod: "Seven Days"
        },
        {
          no: "04",
          category: "SE Students",
          books: "02",
          lPeriod: "Seven Days"
        },
        {
          no: "05",
          category: "TE Students",
          books: "02",
          lPeriod: "Seven Days"
        },
        {
          no: "06",
          category: "BE Students",
          books: "02",
          lPeriod: "Seven Days"
        },
        {
          no: "07",
          category: "ME Students",
          books: "02",
          lPeriod: "Fourteen Days"
        },
        {
          no: "08",
          category: "FE,SE,TE,BE Students (Book Bank Social Welfare)",
          books: "Set of 5 Books",
          lPeriod: "One Semester"
        }
      ],
      issueRules: [
        'Two Books are issued to the Students for 08 days which can be reissued once.',
        'Fine charged for late return of Books @ Rs. 2.00 /Day.',
        'No. Books can be issued once the fine crosses Rs. 100.',
        'Periodicals / Newspapers and CDs are not issued to any student and Faculty.',
        'Reference Books and Library copies will not be issued to any student and Faculty.',

      ],
      circulations: [
        'No library material will be taken out of the library without the permission of the Librarian.',
        'Books/Periodicals or any other library material will be issued only on production of a valid I-card.',
        'Books once issued will not be returned in the same day.',
        'No library Material can be issued to a person on someone else’s I-Card.',
        'Each student can borrow 2 books on one card for a period of 07 days.',
        'A book issued can be renewed on or before the due date,“Once” for a period of 08 more days only.',
        'Issue of books will be restored once the dues are paid in the accounts section and the receipt is shown to the Librarian.',
        'Students should inspect the condition of the book before borrowing it and inform the Librarian about the missing or torn pages if any. The concerned student will be held responsible for the same. Later at the time of returning the book.',
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
p {
  margin-bottom: 0.6rem;
}

::v-deep(.p-datatable) {
  .p-datatable-header {
    background: #e6e6e6;
    color: #404040;
  }

  .p-datatable-thead > tr > th {
    background: #e6e6e6;
    color: #404040;
  }
}
</style>
